export const ROUTE_LOGIN_APP = `/login`;

export const ROUTE_DASHBOARD = "/dashboard";
export const ROUTE_TICKETS = "/tickets";
export const ROUTE_FILE_CONFIGURATION = "/file-configuration";
export const ROUTE_FILE_LIST_CONFIGURATION = (category_id: string, category_name: string) => `/file-list/${category_id}/${category_name}`;

export const ROUTE_ANNOUNCEMENTS = "/announcements";
export const ROUTE_ANNOUNCEMENTS_CONFIG = `/announcements-config`;
export const ROUTE_ANNOUNCEMENTS_CONFIG_PARAM = (tab:any) => `/announcements-config/${tab}`;
export const ROUTE_CREATE_AUDIENCE = `/create-audience`;
export const ROUTE_EDIT_AUDIENCE = (id:string) => `/edit-audience/${id}`;
export const ROUTE_VIEW_AUDIENCE_QUERY = (id:string) => `/view-audience/${id}`;

